import { GridColDef } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { Switch, Tooltip, styled } from "@mui/material";
import { formatDate } from "utils/date-utils";
import useGridColumns from "hooks/shared/useGridColumns";
import { Box } from "@mui/system";
import { useTaskContext } from "hooks/tasks";


type useTaskProblemLogColumnsResult = [
  GridColDef[]
];

type useTaskProblemLogColumnsSignature = 
  (onUpdateProblem: (problemLogId: number, resolution: boolean, problemDescription?: string) => void, hasAddProblemFlagPermission: boolean, hasRemoveProblemFlagPermission: boolean, isTaskCompleted: boolean) 
    => useTaskProblemLogColumnsResult;

const useTaskProblemLogColumns: useTaskProblemLogColumnsSignature = 
  (onUpdateProblem: (problemLogId: number, resolution: boolean, problemDescription?: string) 
  => void, hasAddProblemFlagPermission: boolean, hasRemoveProblemFlagPermission: boolean, isTaskCompleted: boolean) => {

  const ProblemLogSwitch = styled(Switch)(({ }) => ({
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            '& .MuiSwitch-thumb': {
                backgroundColor: '#1976d2',
            }
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: '#FF0000'
    },
    '& .MuiSwitch-track': {
        backgroundColor: '#FF0000'
    },
}));

  const taskContext = useTaskContext();
  const { task } = taskContext;

  const columnBase: GridColDef[] = [
    {
        field: 'note',
        headerName: 'Problem',
        headerClassName: 'header',
        sortable: true,
        hideSortIcons: false,
        resizable: true,
        flex: 1,
        width: 250,
        editable: !isTaskCompleted && hasAddProblemFlagPermission,
        renderHeader: (params) => {
            return (
                <Tooltip title="Problem" arrow>
                    <div >{"Problem"}</div>
                </Tooltip>
            )
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.value} arrow>
              <div style={{ whiteSpace: 'break-spaces' }}>{params.value}</div>
            </Tooltip>
          )
        }
    },
    {
        field: 'createdOn',
        headerName: 'Reported On',
        headerClassName: 'header',
        sortable: true,
        hideSortIcons: false,
        resizable: true,
        minWidth: 140,
        renderCell: (params) => {
            return (<div>{formatDate(params.value)}</div>)
        }
    },
    {
      field: 'userName',
      headerName: 'Reported By',
      headerClassName: 'header',
      sortable: true,
      hideSortIcons: false,
      resizable: true,
      width: 150,
  },
  {
      field: 'isProblemResolved',
      headerName: 'Resolved',
      headerClassName: 'header',
      sortable: true,
      hideSortIcons: false,
      resizable: true,
      minWidth: 150,
      renderCell: (params) => {
          return (
              <Box>
                {!params.row.isProblemResolved && 'No'}
                <ProblemLogSwitch 
                disabled = {isTaskCompleted || !hasRemoveProblemFlagPermission}
                onChange={() => {
                  params.row.isProblemResolved = !params.row.isProblemResolved;
                  onUpdateProblem(+params.row.id, params.row.isProblemResolved, undefined)
                }}
                checked={params.row.isProblemResolved}/>
                {params.row.isProblemResolved && 'Yes'}
              </Box>
          )
      }
  }
] as GridColDef[];

const [ columns, setColumns ] = useState<GridColDef[]>(columnBase);

useEffect(() => {  
  let newColumns: GridColDef[] = [];
  newColumns.push(...columnBase);
  setColumns(newColumns);
}, [task]);  

  return [
    columns,
  ];
};

export default useTaskProblemLogColumns;